document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('mousemove', (e) => {
    const cursor = document.getElementById('cursor');
    setTimeout(() => {
      cursor.style.left = `${e.pageX}px`;
      cursor.style.top = `${e.pageY}px`;
    }, 75);
  });

  const cursor = document.getElementById('cursor');
  const links = document.querySelectorAll('a');
  const ctaElements = document.querySelectorAll('.cta');
  const btnElements = document.querySelectorAll('.btn');
  const linkElements = document.querySelectorAll('.link');
  const inputElements = document.querySelectorAll('input, textarea');

  links.forEach((link) => {
    link.addEventListener('mouseover', () => {
      cursor.classList.remove('hv-link', 'hv-cta');
      if (link.classList.contains('cta')) {
        cursor.classList.add('hv-cta');
      } else {
        cursor.classList.add('hv-link');
      }
    });

    link.addEventListener('mouseout', () => {
      cursor.classList.remove('hv-link', 'hv-cta');
    });
  });

  ctaElements.forEach((ctaElement) => {
    ctaElement.addEventListener('mouseover', () => {
      cursor.classList.remove('hv-link');
      cursor.classList.add('hv-cta');
    });

    ctaElement.addEventListener('mouseout', () => {
      cursor.classList.remove('hv-cta');
    });
  });

  linkElements.forEach((linkElement) => {
    linkElement.addEventListener('mouseover', () => {
      cursor.classList.remove('hv-cta');
      cursor.classList.add('hv-link');
    });

    linkElement.addEventListener('mouseout', () => {
      cursor.classList.remove('hv-link');
    });
  });

  btnElements.forEach((btnElement) => {
    btnElement.addEventListener('mouseover', () => {
      cursor.classList.remove('hv-link');
      cursor.classList.add('hv-cta');
    });

    btnElement.addEventListener('mouseout', () => {
      cursor.classList.remove('hv-cta');
    });
  });

  inputElements.forEach((inputElement) => {
    inputElement.addEventListener('mouseover', () => {
      cursor.classList.remove('hv-cta');
      cursor.classList.add('hv-link');
    });

    inputElement.addEventListener('mouseout', () => {
      cursor.classList.remove('hv-link');
    });
  });
});
